export default __webpack_public_path__ + "static/media/person-back.c48d680b.png";